<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  <div>
    <div style="width:100%;">
      <table mat-table [dataSource]="whereList">

        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="width: 50px;">序號</th>
          <td mat-cell *matCellDef="let element">{{element.id}}</td>
        </ng-container>

        <!-- type Column -->
        <ng-container matColumnDef="type1">
          <th mat-header-cell *matHeaderCellDef style="width: 80px;">類型</th>
          <td mat-cell *matCellDef="let element" style="width: 80px;">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
              <mat-select [(ngModel)]="element.type1">
                @for (type of typeList; track type) {
                <mat-option [value]="type">
                  {{ type }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>
        <!-- Label Column -->
        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef style="width: 120px;">欄位中文名稱</th>
          <td mat-cell *matCellDef="let element" style="width: 120px;">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
              <input matInput [(ngModel)]="element.label">
            </mat-form-field>
          </td>
        </ng-container>

        <!-- FieldName Column -->
        <ng-container matColumnDef="fieldName">
          <th mat-header-cell *matHeaderCellDef style="width: 120px;">SQL欄位名稱</th>
          <td mat-cell *matCellDef="let element" style="width: 120px;">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
              <input matInput [(ngModel)]="element.fieldName">
            </mat-form-field>
          </td>
        </ng-container>

        <!-- DataType Column -->
        <ng-container matColumnDef="dataType">
          <th mat-header-cell *matHeaderCellDef style="width: 80px;">資料型態</th>
          <td mat-cell *matCellDef="let element" style="width: 80px;">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
              <mat-select [(ngModel)]="element.dataType">
                @for (type of dataTypeList; track type) {
                <mat-option [value]="type">
                  {{ type }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Compare Column -->
        <ng-container matColumnDef="compare">
          <th mat-header-cell *matHeaderCellDef style="width: 100px;">運算</th>
          <td mat-cell *matCellDef="let element" style="width: 100px;">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
              <mat-select [(ngModel)]="element.compare">
                @for (item of compareList; track item.id) {
                <mat-option [value]="item.id">
                  {{ item.name }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef style="width: 100px;">運算資料</th>
          <td mat-cell *matCellDef="let element" style="width: 100px;">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full"
              [ngClass]="{'yellow-bg': element.type1 === '參數'}">
              <input matInput [(ngModel)]="element.value">
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef style="width: 100px;">說明</th>
          <td mat-cell *matCellDef="let element" style="width: 100px;">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
              <input matInput [(ngModel)]="element.description">
            </mat-form-field>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="action-buttons mt-4 text-right">
    <button cdkFocusInitial (click)="onConfirm()" class="btn-primary mr-2">確定</button>
    <button (click)="onCancel()" class="btn-neutral">取消</button>
  </div>
</mat-dialog-actions>